import React, {Fragment, useMemo, useState} from 'react';
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import { Handle, Position } from 'react-flow-renderer';

import {WIZARD_GROUP_TYPES, wizardGroupInterface, wizardItemInterface} from "../WizardItem/wizardItemInterface";
import SvgIcons from "../../Icons/SvgIcons";
import WizardNodeActionButtons from "./WizardNodeActionButtons";
import WizardNodeLabel from "./WizardNodeLabel";
import WizardNodeVisibleEyeBall from "./WizardNodeVisibleEyeBall";


const WizardNode = (props) => {

  const {data} = props;
  const {wizardActiveItem, noGroupAvailable, leadStep, wizardGroup, isHugeWizard, workSheetWizardSelectionsActive,
    workSheetWizardSelectionsClick, workSheetWizardSelectionsGroupSelected} = data;

  const [showButtons, setShowButtons] = useState(!isHugeWizard && !workSheetWizardSelectionsActive);

  // const {areSameSiblingGroups} = getWizardGroupLogic(wizardGroup, wizardActiveItem);

  const wizardGroupTitle = useMemo(() => {
    if (wizardGroup.noAvailableFilters) {
      return (
        <Fragment>
          <div className="wizard-group__alert-icon">{SvgIcons.warning}</div>
          <div className="wizard-group__alert-text"><FormattedMessage id="wizard.group.type.noFilters"/></div>
        </Fragment>
      )
    }
    if (wizardGroup.title) {
      return <div className="wizard-group__alert-text">{wizardGroup.title}</div>
    }
    return null
  }, [wizardGroup]);

  const onWizardNodeClick = () => {
    if (workSheetWizardSelectionsActive && workSheetWizardSelectionsClick) {
      workSheetWizardSelectionsClick(wizardGroup);
      return
    }
    if (!showButtons) {
      setShowButtons(true);
    }
  }

  return (
    <div className={"wizard-group wizard-group--" + wizardGroup.nodeType
      + (noGroupAvailable ? " wizard-group--not-available" : "")
      + (workSheetWizardSelectionsActive ? " wizard-group--clickable" : "")
      + (workSheetWizardSelectionsActive
      && (workSheetWizardSelectionsGroupSelected === wizardGroup.id) ? " wizard-group--selected" : "")}
         onClick={onWizardNodeClick}>
      <Handle type="target" position={Position.Top} />
      <div className="wizard-group__type">
        {wizardGroup.id}. <FormattedMessage id={"wizard.group.type." + wizardGroup.nodeType}/>
        {wizardGroup.clickOnLogic ? "*" : null}
      </div>
      {leadStep ? (
        <div className="wizard-group__step">
          {leadStep}
        </div>
      ) : null}
      <div className="wizard-group__alert">
        {wizardGroupTitle}
      </div>
      <div className="wizard-group__title">
        {wizardGroup.nodeType === WIZARD_GROUP_TYPES.custom
          ? wizardGroup.productCartTitle || wizardGroup.groupName
          : wizardGroup.customDisplayName || wizardGroup.groupName}
      </div>
      {showButtons ? (
        <Fragment>
          <WizardNodeVisibleEyeBall wizardGroup={wizardGroup} wizardActiveItem={wizardActiveItem}/>
          <WizardNodeLabel wizardGroup={wizardGroup} wizardActiveItem={wizardActiveItem}/>
          <WizardNodeActionButtons wizardGroup={wizardGroup} wizardActiveItem={wizardActiveItem}/>
        </Fragment>
      ) : <div className="wizard-group__actions"/>}
      <Handle type="source" position={Position.Bottom} />
    </div>
  )
};

WizardNode.propTypes = {
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  data: PropTypes.shape({
    wizardActiveItem: PropTypes.shape(wizardItemInterface).isRequired
  }).isRequired
}

export default WizardNode
